import { CSSObject } from '@mantine/core';
import { MantineThemeComponent } from '../../types';
import { textVariants } from '../../tokens/typography/typography';

const InputDefaultConfig: MantineThemeComponent = {
	defaultProps: {},
	styles: () => ( {
		input: {
			background: 'var(--color-bg-surface)',
			color: 'var(--color-text-primary)',
			borderColor: 'var(--color-outline-default)',
			...( textVariants.footnote as CSSObject )
		},
		placeholder: {
			...( textVariants.footnote as CSSObject ),
			color: 'var(--color-text-light) !important'
		},
		icon: {
			color: 'var(--color-text-light)'
		}
	} )
};

export default InputDefaultConfig;
